module.exports = __webpack_public_path__ + "img/big-loader.339393ae.svg";